export default __webpack_public_path__ + "static/media/team113.12e73861.JPG";